export default __webpack_public_path__ + "static/media/baseline-keyboard_arrow_down-24px.8d464409.svg";